import { __rest, __assign } from 'tslib';
import React, { useContext, useMemo, useCallback } from 'react';
import cn from 'classnames';
import { Pagination as Pagination$1 } from '../../../../pagination/esm';
import { SelectDesktop } from '../../../../select/esm/desktop';
import { TableContext } from '../table-context/index.js';
import { CustomSelectField } from './select-field/index.js';
import '../../../../button/esm';

var styles = {"component":"table__component_1t1zk","pagesWrapper":"table__pagesWrapper_1t1zk","tag":"table__tag_1t1zk","tagActive":"table__tagActive_1t1zk","pagination":"table__pagination_1t1zk","menu":"table__menu_1t1zk","option":"table__option_1t1zk"};
require('./index.css');

var Pagination = function (_a) {
    var _b = _a.perPage, perPage = _b === void 0 ? 25 : _b, _c = _a.possiblePerPage, possiblePerPage = _c === void 0 ? [25, 50, 100] : _c, _d = _a.onPerPageChange, onPerPageChange = _d === void 0 ? function () { return null; } : _d, _e = _a.hidePerPageSelect, hidePerPageSelect = _e === void 0 ? false : _e, pagesCount = _a.pagesCount, _f = _a.onPageChange, onPageChange = _f === void 0 ? function () { return null; } : _f, className = _a.className, dataTestId = _a.dataTestId, restPaginationProps = __rest(_a, ["perPage", "possiblePerPage", "onPerPageChange", "hidePerPageSelect", "pagesCount", "onPageChange", "className", "dataTestId"]);
    var wrapperRef = useContext(TableContext).wrapperRef;
    var options = useMemo(function () {
        return Array.from(new Set(possiblePerPage.concat(perPage)))
            .sort(function (a, b) { return a - b; })
            .map(function (value) { return ({
            key: value.toString(),
            content: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u043E ".concat(value),
        }); });
    }, [perPage, possiblePerPage]);
    var handlePerPageChange = useCallback(function (_a) {
        var selected = _a.selected;
        onPerPageChange(Number(selected === null || selected === void 0 ? void 0 : selected.key));
    }, [onPerPageChange]);
    var handlePageChange = useCallback(function (pageIndex) {
        onPageChange(pageIndex);
        setTimeout(function () {
            if (wrapperRef.current) {
                wrapperRef.current.scrollIntoView();
            }
        }, 0);
    }, [onPageChange, wrapperRef]);
    return (React.createElement("div", { className: cn(styles.component, className), "data-test-id": dataTestId },
        hidePerPageSelect === false && (React.createElement(SelectDesktop, { options: options, selected: perPage.toString(), onChange: handlePerPageChange, preventFlip: false, size: 's', className: styles.select, optionsListClassName: styles.menu, optionClassName: styles.option, Field: CustomSelectField })),
        pagesCount > 1 && (React.createElement(Pagination$1, __assign({ pagesCount: pagesCount, onPageChange: handlePageChange, className: styles.pagination }, restPaginationProps)))));
};

export { Pagination };
